(function () {
  // Alleen op de wachtwoord/coming-soon pagina draaien
 if (!document.body.classList.contains('template-password')) return;

  const root = document.getElementById('junoa-bubbles');
  if (!root) return;

  const COUNT = 26; // hoeveel belletjes (meer of minder mag)
  for (let i = 0; i < COUNT; i++) {
    const b = document.createElement('span');
    b.className = 'bubble';

    const size = 80 + Math.random() * 100;      // 12–40 px
    const left = Math.random() * 100;          // willekeurige startpositie
    const duration = 14 + Math.random() * 16;  // hoe snel ze omhoog gaan
    const delay = Math.random() * 8;           // niet allemaal tegelijk
    const drift = (Math.random() * 80 - 40);   // klein beetje wiebelen

    b.style.setProperty('--s', size + 'px');
    b.style.setProperty('--x', left + 'vw');
    b.style.setProperty('--d', duration + 's');
    b.style.setProperty('--delay', delay + 's');
    b.style.setProperty('--drift', drift + 'px');
    root.appendChild(b);
  }
})();
